var EditVideoAlbumView = EditAlbumView.extend({
  thumbnailGeometries: ['320x180']
});
